<template>
  <notification :notification="notification">
    <template slot="title">
      您的定时动态
      <router-link :to="{name: 'threads.show', params: {dynamic_id: notification.relation.dynamic_id}}">
        《{{ notification.relation.dynamic_title }}》
      </router-link>已发布成功
    </template>
  </notification>
</template>

<script>
import Notification from './notification'

export default {
  components: { Notification },
  props: {
    notification: {
      type: Object,
      default: null
    }
  }
}
</script>
